import { Component, OnInit, Input } from '@angular/core';
import { PermissionService } from '../../../service/component_dependent/permission.service';

@Component({
  selector: 'app-permissions-list',
  templateUrl: './permissions-list.component.html',
  styleUrls: ['./permissions-list.component.scss']
})
export class PermissionsListComponent implements OnInit {

  @Input() public permissions = [];
  @Input() public permissionsSelectedID = [];

  @Input() public maxItemPerPage: number;
  @Input() public page: number;
  @Input() public lastPage: number;
  @Input() public total: number;

  @Input() public keyword: string;

  constructor(private permissionService: PermissionService) {
    this.maxItemPerPage = 16;
    this.page = 0;
    this.keyword = "";
  }

  ngOnInit() {
    this.getPermissions(1, undefined);
  }

  public getPermissions(page, keyword) {
    if (keyword == undefined) {
      this.permissionService.getPermissions(this.maxItemPerPage, page).subscribe(
        data => {
          this.reassignVariablesPermissions(data.data);
        }
      );
    } else {
      this.permissionService.getPermissionsWithKeyword(this.maxItemPerPage, page, keyword).subscribe(
        data => {
          this.reassignVariablesPermissions(data.data);
        }
      );
    }
  }

  private reassignVariablesPermissions(data) {
    this.permissions = data.data;
    this.maxItemPerPage = data.per_page;
    this.page = data.current_page;
    this.lastPage = data.last_page;
    this.total = data.total;
  }

  public onMousePressedCheckbox(id) {
    var childNodes;

    childNodes = document.getElementById(id).childNodes;
    childNodes[0].checked = !childNodes[0].checked;

    if (childNodes[0].checked) {
      this.permissionsSelectedID.push(id);
      this.viewGrantedPermissionHandler("add", id);
    } else {
      this.permissionsSelectedID.splice(this.permissionsSelectedID.indexOf(id), 1);
      this.viewGrantedPermissionHandler("remove", id);
    }

  }

  public clearAll(){
    var divGrantedPermission = document.getElementById("divGrantedPermission");

    while(divGrantedPermission.hasChildNodes()){
      divGrantedPermission.removeChild(divGrantedPermission.firstChild);
    }
    
    this.permissionsSelectedID = [];
  }

  public viewGrantedPermissionHandler(mode: string, id: number) {

    var divGrantedPermission = document.getElementById("divGrantedPermission");

    if (divGrantedPermission != null) {

      switch (mode) {
        case "add": {

          var obj = {
            ids: [id],
          };

          const permission = this.permissions.filter(data => data.id == id)
          
          if(permission.length > 0){
            var label = document.createElement("label");
                label.id = "p" + id;
                label.textContent = permission[0].name;
                label.classList.add("colorV1White");
                label.classList.add("btnOval");
                label.classList.add('fontColorV1Blue');
                label.classList.add("lblGrantedPermission");
                divGrantedPermission.appendChild(label);
          }

          break;
        }

        case "remove":{
          document.getElementById("p"+id).remove();
          break;
        }
      }
    };
  }
}
